import React from "react";
import { getString, isAFunction } from "../../utilities";
import { getLangCode } from "../../config";

export default function SubscriptionCard({ plan, setPlan = () => {}, setPlanAmount, subscription, planData, isBest }) {
  const getSubStyle = (p) => {
    const disabledStyle = !planData ? "disabled" : "";
    const activeStyle = plan === p ? "active" : "";
    return `sub-card ${disabledStyle} ${activeStyle}`;
  };

  const setSubscription = () => {
    if (!planData) return;

    if (isAFunction(setPlanAmount)) {
      setPlanAmount(planData?.[subscription].amount);
    }
    setPlan(subscription);
  };

  const renderBest = () => {
    if (isBest) {
      return (
        <div className={`sub-card-best ${getLangCode()}`}>
          <span className="currency">{getString("currencySymbol.usd")}</span>
          <span>{getString(`subscribe.plans.best`)}</span>
        </div>
      );
    }

    return null;
  };

  const renderCost = () => {
    const costData = planData?.[subscription];

    return (
      <div className="cost">
        <div className="dollars">
          <sup>{getString("currencySymbol.usd")}</sup>
          {costData?.total.dollars}
        </div>

        <div className="cents-term">
          <div className="cents">{costData?.total.cents}</div>
          <div className="term">
            {getString(subscription === "m1" ? "subscribe.plans.terms.month" : "subscribe.plans.terms.year")}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div
      data-testid={`subscription-card-${subscription}`}
      className={getSubStyle(subscription)}
      onClick={setSubscription}
    >
      {renderBest()}

      <div className="sub-card-title">{getString(`subscribe.plans.${subscription}.title.0`)}</div>

      <div className="sub-card-container">
        {renderCost()}

        <button type="button" className="button-flat-color pt-green">
          {getString("choose.0")}
        </button>
      </div>
    </div>
  );
}
